import { SingleSelectDropdown } from "@monsterindia/global-ui-components";
import React, { memo } from "react";
import { Controller } from "react-hook-form";

import {
  DropdownOptionType,
  SingleDropDownControllerProps,
} from "../dropdownController.types";

const SingleDropDownController = ({
  name,
  control,
  options,
  onSelect,
  onChangeHandler,
  placeholder,
  errorMessage,
  isDisabled,
  isRequired = true,
  isSearchable,
  isLoading,
}: SingleDropDownControllerProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={isRequired ? { required: "This field is required" } : undefined}
      render={({ field }) => {
        return (
          <SingleSelectDropdown
            {...field}
            id={name}
            width="l1-w-full"
            options={options}
            className="l1-w-full"
            loadingText={isLoading ? "Loading..." : "No options available"}
            placeholder={placeholder}
            onChangeHandler={onChangeHandler}
            isSearchable={isSearchable ?? false}
            selectedValue={field.value ?? null}
            handleDropdownSelect={(selected: DropdownOptionType) => {
              field.onChange(selected);
              onSelect(selected);
            }}
            disabled={isDisabled}
            errorText={errorMessage}
          />
        );
      }}
    />
  );
};

export default memo(SingleDropDownController);
